import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MoreProjects from "./Components/UI/moreproject/MoreProjects";
import EnglishPage from "./Components/UI/English/EngliahPage";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Routes>
        <Route path="/" element={<App />}></Route>

        <Route path="/imaProjects" element={<MoreProjects />}></Route>

        <Route path="/englishpage" element={<EnglishPage />}></Route>
      </Routes>
    </React.StrictMode>
  </BrowserRouter>
);
